export default class PolicyModule {

}
